/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetRecurringTemplateQueryResponse, GetRecurringTemplatePathParams, GetRecurringTemplate400, GetRecurringTemplate401, GetRecurringTemplate403, GetRecurringTemplate404, GetRecurringTemplate409, GetRecurringTemplate500 } from "../../types/financialHubController/GetRecurringTemplate.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getRecurringTemplate } from "../../client/financialHubController/getRecurringTemplate.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getRecurringTemplateQueryKey = (organizationId: GetRecurringTemplatePathParams["organizationId"] | undefined, templateId: GetRecurringTemplatePathParams["templateId"] | undefined) => [{ url: '/api/organizations/:organizationId/financial/recurring/templates/:templateId', params: {organizationId:organizationId,templateId:templateId} }] as const

export type GetRecurringTemplateQueryKey = ReturnType<typeof getRecurringTemplateQueryKey>

export function getRecurringTemplateQueryOptions(organizationId: GetRecurringTemplatePathParams["organizationId"] | undefined, templateId: GetRecurringTemplatePathParams["templateId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getRecurringTemplateQueryKey(organizationId, templateId)
        return queryOptions<GetRecurringTemplateQueryResponse, ResponseErrorConfig<GetRecurringTemplate400 | GetRecurringTemplate401 | GetRecurringTemplate403 | GetRecurringTemplate404 | GetRecurringTemplate409 | GetRecurringTemplate500>, GetRecurringTemplateQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && templateId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getRecurringTemplate(organizationId!, templateId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get a recurring template
 * {@link /api/organizations/:organizationId/financial/recurring/templates/:templateId}
 */
export function useGetRecurringTemplate<TData = GetRecurringTemplateQueryResponse, TQueryData = GetRecurringTemplateQueryResponse, TQueryKey extends QueryKey = GetRecurringTemplateQueryKey>(organizationId: GetRecurringTemplatePathParams["organizationId"] | undefined, templateId: GetRecurringTemplatePathParams["templateId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetRecurringTemplateQueryResponse, ResponseErrorConfig<GetRecurringTemplate400 | GetRecurringTemplate401 | GetRecurringTemplate403 | GetRecurringTemplate404 | GetRecurringTemplate409 | GetRecurringTemplate500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getRecurringTemplateQueryKey(organizationId, templateId)
         

         const query = useQuery({
          ...getRecurringTemplateQueryOptions(organizationId, templateId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetRecurringTemplate400 | GetRecurringTemplate401 | GetRecurringTemplate403 | GetRecurringTemplate404 | GetRecurringTemplate409 | GetRecurringTemplate500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}